import { Box, Container, Breadcrumb } from '@legion-ui/core';
import PageHeader from '@/components/PageHeader';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { modalStore, ModalType } from '@/store/modal';
import Button from '@/components/Button';
import { ToastContainer } from 'react-toastify';
import ModalContainer from '@/components/ModalContainer';
import UserInfoSection from '@/components/UserInfoSection';
import UserRoleSection from '@/components/UserRoleSection';
//import UserStatusSection from '@/components/UserStatusSection';
import { useUserByUsername } from '@/hooks/useUserByUsername';
import { tableStore } from '@/store/table';
import { useDeveloperInputStore } from '@/store/police/developer.input';
import { usePublisherInputStore } from '@/store/police/publisher.input';
import { useAdminInputStore } from '@/store/police/admin.input';
import useLoadingStore from '@/store/loading';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDraftInputState } from '@/store/police/draft.input';
import { frontConfig } from '@/config/front-config';


const ControlPolicy = () => {
  // Get User ID from state location
  const [isLocationReady, setIsLocationReady] = useState(false);
  const developerInputStore = useDeveloperInputStore((state) => state);
  const publisherInputStore = usePublisherInputStore((state) => state);
  const adminInputStore = useAdminInputStore((state) => state);
  const draftInputState = useDraftInputState((state) => state);
  const location = useLocation();
  const { superAdminUsers } = frontConfig();

  const { userId } = location && location.state ? location.state.user : { userId: undefined };
  const params = useParams();
  const { username } = params;
  const { pathname } = location;

  if (superAdminUsers.includes(username!)) {
    return <Navigate to="/users" replace />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useUserByUsername(username!, userId);

  // Modal Store
  const { activeModal, toggleModal } = modalStore();
  const tableStored = tableStore((state) => state);

  const handleUpdate = () => {
    toggleModal(ModalType.Update);
  };

   // Detect apakah datang dari requests atau users
  const isFromRequests = pathname.startsWith('/requests');
  const backLink = isFromRequests ? '/requests' : '/users';
  const breadcrumbLabel = isFromRequests ? 'Requests List' : 'Users List';
  const isLoading = user.length === 0 || typeof user[0] === 'undefined';
  const currentUser = !isLoading ? user[0] : undefined; // ✅ Atau pakai ini

  return (
    <article className="flex items-center justify-center min-h-screen">
      <Container>
        {/* Notification */}
        <ToastContainer />
        
        {/* Modal - hanya render jika tidak loading */}
        {!isLoading && currentUser && (
          <ModalContainer
            activeModal={activeModal}
            toggleModal={toggleModal}
            user={currentUser}
          />
        )}

        {/* Header & Breadcrumb */}
        <Box as="header">
          <Breadcrumb
            className="mb-4"
            items={[
              {
                label: (
                  <Link
                    to={backLink}
                    onClick={() => {
                      tableStored.setSearchTerm('');
                      tableStored.setCurrentPage(1);
                      publisherInputStore.clear();
                      adminInputStore.clear();
                      developerInputStore.clear();
                      draftInputState.clear();
                    }}
                  >
                    <span className="text-sm opacity-50">{breadcrumbLabel}</span>
                  </Link>
                ),
              },
              {
                label: (
                  <Link to={pathname}>
                    <span className="text-[#0649CF] text-sm">
                      Control Policy
                    </span>
                  </Link>
                ),
              },
            ]}
            separator="/"
          />
          <PageHeader title="Control Policy" />
        </Box>

        {/* Handle User Section */}
        <Box as="section" mt="1.5rem">
          <div className="flex flex-col w-full p-6 border border-[#E0E0E0] rounded-lg">
            <UserInfoSection 
              user={currentUser} 
              toggleModal={toggleModal} 
              isLoading={isLoading}
            />
            <UserRoleSection 
              user={currentUser} 
              toggleModal={toggleModal}
              isLoading={isLoading} 
            />
            {/* <UserStatusSection
              toggleModal={toggleModal}
              isUserStatusActive={
                publisherInputStore.userStatus ??
                (user[0].isAllowed as boolean)
              }
              user={user[0]}
            /> */}
            <Box alignX="center" pt="1.5rem">
              <Button
                type="button"
                onClick={handleUpdate} 
                disabled={draftInputState.drafts.length === 0}
              >
                Update
              </Button>
              {/* Tombol reject hanya tampil melalui request list */}
              {isFromRequests && (
                <Button
                  type="button"
                  variant="outline"
                  // onClick={handleReject } // example function to handle reject
                  className="ml-4 bg-red-500 text-white border-red-500 hover:bg-red-600"
                >
                  Reject
                </Button>
              )}
            </Box>
          </div>
        </Box>
      </Container>
    </article>
  );
};

export default ControlPolicy;
